<script lang="ts" setup>
    import GlobalSearchItem from '@/app/common/models/GlobalSearchItem';

    const props = defineProps<{
        result: GlobalSearchItem;
    }>();
</script>

<template>
    <AppSearchModalResult
        :icon="result.contact.contactType == 'client' ? 'fa-user' : 'fa-truck'"
        :icon-tooltip="$t(`contact_type.${result.contact.contactType}`)"
        :result="result"
    >
        <template v-slot>
            <span class="block text-sm text-gray-800">
                {{ result.contact.displayName }}
            </span>
            <span class="block text-xs text-gray-600">
                {{ result.contact.email }}
            </span>
        </template>
    </AppSearchModalResult>
</template>
